// extracted by css-extract-rspack-plugin
var _1 = "cItXf7fmGOPdsBkdqtwbEw--";
var _2 = "rSTnCMohe94EbLp65B2JJg--";
var _3 = "nnOKLuAH1hwtqCdr2jrJug--";
export { _1 as "addPageButton", _2 as "addPageButtonSolidBackground", _3 as "addPageText" }
